<template>
  <Dialog>
    <DialogTrigger>
      {{ $t('Dynamic content') }}
    </DialogTrigger>
    <DialogScrollContent size="lg">
      <DialogHeader>
        <DialogTitle>
          {{ $t('Dynamic content') }}
        </DialogTitle>
      </DialogHeader>
      <div class="table-responsive">
        <table class="table table-striped table-extra-padding">
          <thead>
          <tr>
            <th>{{ $t('Field') }}</th>
            <th>{{ $t('Value') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, name, index) in data" :key="index">
            <td>
              <span v-pre>{{</span><span>dynamicContent.{{ name }}</span><span v-pre>}}</span>
            </td>
            <td>{{ value }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});
</script>
